export default class Scene {
  start () {}
  stop () {}
  pause () {}
  resume () {}
  update () {}
}
